import { PaymentSectionForm } from '../payment-section.interface'

export const getPaymentSectionInitialValues = (form?: PaymentSectionForm): PaymentSectionForm => {
  if (form) {
    return {
      month: form.month,
      year: form.year,
    }
  }

  return {
    month: false,
    year: true,
  }
}
